import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
} from "@/components/ui/form";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Control } from "react-hook-form";
import { Position } from "@/services/positionService";
import { EmployeeFormValues } from "../schemas/employeeFormSchema";

interface DocumentsFormProps {
  control: Control<EmployeeFormValues>;
  positions?: Position[];
}

export const DocumentsForm = ({ control, positions }: DocumentsFormProps) => {
  return (
    <>
      <CardHeader>
        <CardTitle>Documents</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <FormField
          control={control}
          name="taxDocumentsSigned"
          render={({ field }) => (
            <FormItem className="flex flex-row items-start space-x-3 space-y-0">
              <FormControl>
                <Checkbox
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
              <div className="space-y-1 leading-none">
                <FormLabel>Tax Documents Signed</FormLabel>
              </div>
            </FormItem>
          )}
        />
        {/* {positions &&
          positions.map((pos) => (
            <FormField
              key={pos.id}
              control={control}
              name="positionDocuments"
              render={({ field }) => {
                const posDoc = field.value?.find(
                  (doc) => doc.positionId === pos.id
                );
                return (
                  <FormItem className="flex flex-row items-start space-x-3 space-y-0">
                    <FormControl>
                      <Checkbox
                        checked={posDoc?.documentSigned || false}
                        onCheckedChange={(checked) => {
                          const updatedDocs = field.value || [];
                          const docIndex = updatedDocs.findIndex(
                            (doc) => doc.positionId === pos.id
                          );
                          if (docIndex >= 0) {
                            updatedDocs[docIndex].documentSigned = !!checked;
                          } else {
                            updatedDocs.push({
                              positionId: pos.id,
                              documentSigned: !!checked,
                            });
                          }
                          field.onChange(updatedDocs);
                        }}
                      />
                    </FormControl>
                    <div className="space-y-1 leading-none">
                      <FormLabel>{`${pos.tableName} Documents Signed`}</FormLabel>
                    </div>
                  </FormItem>
                );
              }}
            />
          ))} */}
      </CardContent>
    </>
  );
};
